<template>
  <div class="app-forgot-password-msisdn">
    <div class="headline">
      <h4>
        <slot name="headline"></slot>
      </h4>
    </div>
    <p class="subline">
      <slot name="subline"></slot>
    </p>
    <b-form
      :novalidate="true"
    >
      <b-row>
        <b-col class="input-msisdn">
          <!--TODO zukuenftig auf src/components/forms/PhoneNumberInput.vue wechseln -->
          <MsisdnInputValidation
            name="msisdn"
            ref="msisdnInput"
            :msisdn-placeholder="getSlotText('placeholder', '')"
            :msisdn.sync="inputMsisdn"
            :invalid.sync="invalidMsisdn"
            @focus="resetErrorMessages"
          >
            <template slot="lblInput">
              <slot name="label"></slot>
            </template>
            <template slot="txtInvalidRequired">
              <slot name="invalidRequired"></slot>
            </template>
            <template slot="txtInvalidLoginUser">
              <slot name="invalidNumber"></slot>
            </template>
            <template v-for="slot in possibleChildSlotsFor('Msisdn')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </MsisdnInputValidation>
        </b-col>
      </b-row>
      <MessageModal></MessageModal>
      <Stepper
        class="stepper"
        :show-prev="false"
        :disabled-next="loading"
        @next="check()"
      >
        <template slot="btnNext">
          <slot name="cta"></slot>
        </template>
      </Stepper>
    </b-form>
  </div>
</template>

<script>
import { BCol, BForm, BRow } from 'bootstrap-vue'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import isValid from '@/mixins/validators/isValid'
import { mapActions, mapGetters } from 'vuex'
import preFilledInput from '@/mixins/preFilledInput'
import Stepper from '@/components/generic/Stepper.vue'
import validationFlow from '@/mixins/validators/validationFlow'
import MsisdnInputValidation from '@/components/generic/MsisdnInput.vue'
import MessageModal from '@/components/generic/MessageView/MessageList.vue'

export default {
  name: 'ForgotPasswordInputMsisdn',
  components: {
    MessageModal,
    MsisdnInputValidation,
    BForm,
    BRow,
    BCol,
    Stepper
  },
  data () {
    return {
      loading: false,
      invalidMsisdn: false,
      viewError: false
    }
  },
  mounted () {
    // reset error message from previous transactions
    this.resetErrorMessages()
  },
  methods: {
    ...mapActions('forgotPassword', [
      'resetPasswordChannels'
    ]),
    resetErrorMessages () {
      this.$store.commit('clearMessages', {}, { root: true })
    },
    check () {
      if (this.$refs.msisdnInput) {
        this.$refs.msisdnInput.vflowForceFeedback()
      }

      if (!this.invalidMsisdn) {
        this.startLoader()

        this.resetPasswordChannels({ msisdn: this.inputMsisdn })
          .catch((e) => {
          })
          .finally(() => {
            this.stopLoader()
          })
      } else {
        // Ensure live feedback for validation errors
        this.vFlowGetFirstErrorElementName().then(function (result) {
          result = result !== '' ? result : 'passwordresettype'
          const data = {
            type: 'validation',
            message: 'required field missing',
            location: result + ' - unknown'
          }
          if (typeof window.trackingNS?.track?.tracking === 'function') {
            window.trackingNS.track.tracking('error', data)
          }
        })
      }
    }
  },
  computed: {
    ...mapGetters('forgotPassword', [
      'msisdn'
    ])
  },
  mixins: [
    validationMixin,
    isValid,
    preFilledInput('inputMsisdn', 'msisdn'),
    validationFlow

  ],
  props: {
    msisdnPlaceholder: {
      type: String,
      default: '+49'
    }
  },
  validations () {
    return {
      inputMsisdn: {
        required
      }
    }
  }
}
</script>
